import { Injectable } from '@angular/core';
import { JobTriggeredBy } from '../state/job.model';

/**
 * Resolves and opens a dialog with a job creator (e.g. orchestraction)
 */
@Injectable()
export abstract class AbstractJobCreatorResolverService {
  abstract canResolve(triggeredBy: JobTriggeredBy): boolean;
  abstract resolve(triggeredBy: JobTriggeredBy): void;
}
